import React, { FC, useState } from "react";
import { Button, InputField } from "../../forms";
import { ModalPropsDTO } from "../../../typings/generic";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import {
  addressRegex,
  emailReg,
  numReg,
  textReg,
} from "../../../utils/regex";
import { ListPicker } from "../../generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { onAddDept } from "../../../services/department";
import { toast } from "react-toastify";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
  import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import usePositionHook from "../../../hooks/usePositionHook";
import useAppraisalTempHook from "../../../hooks/useAppraisalTempHook";
import useAppraisalHook from "../../../hooks/useAppraisalHook";
 
export default (props: any) => {
  var { control, handleSubmit, watch } = useForm();
   const employeepickHook = usePickerhook();
  const positionpickHook = usePickerhook();
  const templatepickHook = usePickerhook();
  const deptpickHook = usePickerhook();
  const managerpickHook = usePickerhook();
  const { setLoading } = useStateSetter();
  const watchedFields = watch(["title", "date"]);
  const { selectedOrgEmployees } = useEmployeeHook();
  const { orgAppTemplates, getOrgTemplates } = useAppraisalTempHook();
  const { selectedOrgDepts } = useDepartmentHook();
  const { allorgPositions } = usePositionHook();
  const { SelectedOrg, config, authuser } = useStateGetter();
  const { AddAppraisals } = useAppraisalHook();

  const areFieldsFilled =
    watchedFields.every(
      (field) =>
        field !== "" &&
        field !== undefined &&
        managerpickHook.pickedRole &&
        (deptpickHook.pickedRole ||
          employeepickHook.pickedRole ||
          positionpickHook.pickedRole)
    ) && templatepickHook.pickedRole;

  const onSubmit = async (data: any) => {
    var postdata: any;
    var pre_def = {
      lineManagerID: managerpickHook.pickedRole.code,
      organizationID: SelectedOrg.id,
      title: data.title,
      deadlineDate: data.date,
      templateID: templatepickHook.pickedRole.code,
     };

    switch (props.target) {
      case "pos":
        postdata = {
          target: "position",
          positionID: positionpickHook.pickedRole.code,
          ...pre_def,
        };
        break;
      case "empl":
        postdata = {
          target: "employee",
          employeeID: employeepickHook.pickedRole.code,
          ...pre_def,
        };
        break;

      case "dept":
        postdata = {
          target: "dept",
          deptID: deptpickHook.pickedRole.code,
          ...pre_def,
        };
        break;

      default:
        postdata = {
          target: "organization",
          ...pre_def,
        };

        break;
    }
 

    setLoading(true);
    try {
      var response: any = await AddAppraisals(postdata);
      toast.success(response.message);
    } catch (e: unknown) {
      console.log(e);
    } finally {
      setLoading(false);
      props.refresh();
      props.show(false);
    }
  };
  return (
    <>
      <div className="ModalContainer shadow ">
        <div className=" flex flex-col  max-h-[80vh] overflow-y-scroll  rounded-[8px] bg-white w-[40vw] px-4 py-6">
          <p className="font-semibold self-start text-sm ">Add Appraisal</p>
          <InputField
            name="title"
            title="Title"
            placeholder={"Enter title"}
            control={control}
            rules={{
              required: "is required",
              pattern: {
                value: textReg,
                message: "Invalid",
              },
            }}
          />
          {(props.target == "empl" || props.target == "360") && (
            <ListPicker
              fullwidth
              hook={employeepickHook}
              title="Employee"
              list={selectedOrgEmployees?.map((ik: any) => {
                return { name: ik.firstName + " " + ik.lastName, code: ik.id };
              })}
            />
          )}
          {props.target == "pos" && (
            <ListPicker
              fullwidth
              hook={positionpickHook}
              title="Position"
              list={allorgPositions?.map((ik: any) => {
                return { name: ik.positionTitle, code: ik.id };
              })}
            />
          )}
          {props.target == "dept" && (
            <ListPicker
              fullwidth
              hook={deptpickHook}
              title="Department"
              list={selectedOrgDepts?.map((ik: any) => {
                return { name: ik.deptName, code: ik.id };
              })}
            />
          )}
          {props.target != "360" && (
            <ListPicker
              fullwidth
              hook={managerpickHook}
              title="Manager"
              list={selectedOrgEmployees?.map((ik: any) => {
                return { name: ik.firstName + " " + ik.lastName, code: ik.id };
              })}
            />
          )}{" "}
          <div className=" grid grid-cols-2   gap-x-4 ">
            <ListPicker
              fullwidth
              hook={templatepickHook}
              title="Appraisal template"
              list={orgAppTemplates?.map((ik: any) => {
                return { name: ik.name, code: ik.id };
              })}
            />
            <InputField
              name="date"
              title="Deadline date"
              type={"date"}
              placeholder={"Enter title"}
              control={control}
              rules={{
                required: "is required",
                pattern: {
                  value: addressRegex,
                  message: "Invalid",
                },
              }}
            />
          </div>
          <div className=" flex justify-center items-center w-full gap-6">
            <Button
              outlined
              text="Cancel"
              onBtnClick={() => {
                props.show(false);
              }}
            />

            <Button
              disabled={!areFieldsFilled}
              text="Add Appraisal"
              onBtnClick={handleSubmit(onSubmit)}
            />
          </div>
        </div>
      </div>
    </>
  );
};
